/**
 * Directive: gantt
 */
angular.module('acme.common.directive.gantt', [
  'acme.common.service.userPreferences'
])
.directive('gantt', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/gantt/gantt.tpl.html',
      scope: {
          events: '=',
          refresh: '=',
          emptyMessage: '@'
      },

      controller: ['$scope', '$filter', 'UserPreferencesService', function($scope, $filter, UserPreferencesService) {
        
        $scope.gantt = {

            isEmpty: false,
            dateFormat: UserPreferencesService.getDateFormat('fieldDate', 'dateFormat'),
            hourFormat: UserPreferencesService.getDateFormat('standardTime', 'hourFormat'),
            
            init: function() {

                // Watch for requests to update data from parent
                $scope.$watch('refresh', function(type) {

                    if ( type !== false ) {

                        $scope.gantt.isEmpty = $scope.events.data.length === 0;

                        if ( type === 'hard' ) {

                            $scope.$emit('gantt::loading', true);

                            gantt.clearAll();
                            gantt.parse($scope.events);

                            $scope.$emit('gantt::loading', false);
                        }

                        gantt.refreshData();

                        // Reset
                        $scope.refresh = false;
                    }

                });

                // Init once and set config
                $scope.$on('UserPreferencesService:onDateFormatLoad', this.onDateFormatLoad);

                this.config();
                gantt.init('acme-gantt');
            },

            config: function() {

                gantt.config.min_column_width = 70;
                gantt.config.row_height = 40;

                gantt.config.show_progress = true;

                // Don't show Y scroller
                gantt.config.autosize = 'y';

                // Set gantt timeline scroll to first event
                gantt.config.initial_scroll = true;

                gantt.config.task_scroll_offset = 50;

                // The properties of the scale at the top of the page
                gantt.config.scale_unit = "hour";
                gantt.config.date_scale = this.getTimeFormatByKey();
                gantt.config.scale_height = 50;
                gantt.config.subscales = [
                    {unit:"minute", step:15, date:":%i" }
                ];

                // The properties of the tasks, basically 15 minute increments,
                // so duration of a task is d * 15, not 90 for example
                gantt.config.duration_unit = "minute";
                gantt.config.duration_step = "15";

                // No adjustment of the tasks or links
                gantt.config.drag_move = false;
                gantt.config.drag_links = false;
                gantt.config.drag_progress = false;
                gantt.config.drag_resize = false;

                gantt.config.columns = [
                    {name:"text",       label:"Event/Resource",  width:"*", tree:true },
                    {name:"start_date", label:"Start time", align:"center"},
                    {name: "end_date",  label: "End time", align: "center"}
                ];

                gantt.templates.date_grid = function(date){
                    return $filter('date')(date, $scope.gantt.hourFormat);
                };

                gantt.templates.task_class  = function(start, end, task){

                    var clz = "resource";

                    if ( task.is_event ) {
                        clz = "event";
                    } else {
                        if ( task.is_resource_add ) {
                            clz = "add_resource";
                        }

                        if ( !task.fulfilled ) {
                            clz = "reassign";
                        }
                    }

                    if (gantt.getSelectedId() == task.id) {
                        clz = clz + ' bold';
                    }

                    return clz;
                };

                gantt.templates.grid_folder = function(item) {
                    return "<div class='circle'>E</div>";
                };

                gantt.templates.grid_file = function(item) {
                    var icon = 'E';

                    // Special case for events with no resources
                    if ( item.is_event ) {
                        return "<div class='circle'>E</div>";
                    }

                    var clz = 'circle_resource';

                    // TODO figure out why this passes events in here, because event has no parent?
                    if ( item.r_category !== undefined ) {
                        icon = item.r_category.substring(0, 1);
                        if ( !item.fulfilled ) {
                            clz = 'circle_resource_fulfill';
                        }
                    }

                    return "<div class='" + clz + "'>" + icon + "</div>";
                };

                gantt.templates.grid_row_class = function(start, end, task){
                    if ( task.is_resource_add  ) {
                        return "add_resource_link";
                    }

                    var currentSelection = gantt.getSelectedId();
                    if ( task.id == currentSelection ) {
                        return "selected_task";
                    }
                };

                gantt.templates.leftside_text = function(start, end, task){
                    // I am a resource and am not fulfilled
                    if (!task.is_event && !task.fulfilled) {
                        return '<span class="fa-stack text-danger not_fulfilled"><span class="fa fa-circle fa-stack-2x"></span><span class="fa fa-exclamation fa-stack-1x fa-inverse"></span></span>';
                    }

                    // I am an event and have unfulfilled resources
                    if (task.is_event && task.$source.length > 0) {
                        return '<span class="fa-stack text-danger not_fulfilled"><span class="fa fa-circle-thin fa-stack-2x"></span><span class="fa fa-exclamation fa-stack-1x"></span></span>';
                    }
                };

                gantt.templates.link_class = function(link){
                    return "start_to_start";
                };

                // Disable double click
                gantt.attachEvent("onTaskDblClick", function(id,e){
                    return false;
                });

                // Open reassignment/add resource modal
                gantt.attachEvent("onTaskClick", function(id, e) {

                    e.stopPropagation();
                    // Open an event on click
                    var task = gantt.getTask(id);

                    // Scroll to task
                    var taskPos = gantt.getTaskPosition(task, task.start_date, task.end_date);
                    gantt.scrollTo(taskPos.left - gantt.config.task_scroll_offset, taskPos.top);

                });
            },
            
            getTimeFormatByKey: function () {
              var hash = {
                'h:mm a' : '%g%a',
                'HH:mm' : '%H:%i',
                'default': '%g%a'
              };
              return hash[this.hourFormat] || hash['default'];
            },
            
            onDateFormatLoad: function (e, data) {
              $scope.gantt.dateFormat = UserPreferencesService.getDateFormat('fieldDate', 'dateFormat');
              $scope.gantt.hourFormat = UserPreferencesService.getHourFormat('standardTime', 'hourFormat');
            }

        };

        $scope.gantt.init();

      }]

    };

}]);